import React, { useState } from "react";

const MouseOverCard = ({ item }) => {
  const [changeImg, setChangeImg] = useState(true);
  return (
    <div className="rounded-tr-xl rounded-bl-xl relative h-44">
      <img
        src={changeImg ? item.image1 : item.image2}
        className="h-full rounded-tr-3xl rounded-bl-3xl shadow-lg "
        alt=""
        onMouseOver={() => setChangeImg(false)}
        onMouseOut={() => setChangeImg(true)}
      />
      <h1 className="my-3 text-center">CARE:NEL PRODUCT</h1>
      {changeImg && (
        <p className="absolute bottom-0 text-center bg-yellow-200 w-full rounded-bl-3xl py-1">
          CARE:NEL
        </p>
      )}
    </div>
  );
};

export default MouseOverCard;
